import { List } from "@mantine/core";
import { generatePath, Link, useParams } from "react-router";
import { ROUTES } from "../../../../../routes";
import type { Paragraph6CreditErrorMessageDetailProps } from "../Paragraph6CreditErrorMessage";

function MasterErrors({
  paragraph6CreditErrors
}: Paragraph6CreditErrorMessageDetailProps) {
  const { projectId } = useParams<{ projectId: string }>();
  const masterErrors = paragraph6CreditErrors.some(
    (error) => error.master_data_check_failed
  );

  if (!masterErrors) {
    return null;
  }

  const companiesPath = projectId
    ? generatePath(ROUTES.project.companies, { projectId })
    : undefined;

  return (
    <List.Item>
      {companiesPath ? (
        <Link to={companiesPath}>notwendige Unternehmensdaten</Link>
      ) : (
        <strong>notwendige Unternehmensdaten</strong>
      )}
    </List.Item>
  );
}

export { MasterErrors };
